import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Output,
    ViewChild,
} from '@angular/core';
import { OpsAlarmMonitoringComponent } from '@pages/ops-alarm/ops-alarm-monitoring/ops-alarm-monitoring.component';
import { CssVarService } from '@service/css-vars.service';
import { NavigationService } from '@service/navigation.service';
import { OpsAlarmMonitoringService } from '@service/ops-alarms/ops-alarm-monitoring.service';
import { PaginationStrategy } from '@service/pagination-strategy.service';
import { ResponsiveService } from '@service/responsive.service';
import { StaticPaginationStrategy } from '@service/static-pagination-strategy';

const DEFAULT_ITEMS_PER_PAGE = 1;

@Component({
    selector: 'app-dashboard-panel-alarms',
    templateUrl: './dashboard-panel-alarms.component.html',
    styleUrls: ['./dashboard-panel-alarms.component.scss'],
    providers: [
        {
            provide: PaginationStrategy,
            useValue: new StaticPaginationStrategy(DEFAULT_ITEMS_PER_PAGE),
        },
    ],
    standalone: false
})
export class DashboardPanelAlarmsComponent
    extends OpsAlarmMonitoringComponent
    implements OnInit, OnDestroy
{
    @ViewChild('mainContent', { static: true })
    public tableBodyContainer: ElementRef;
    @Output() onDeleteClicked = new EventEmitter<void>();
    @Output() onResourceNotFound = new EventEmitter<void>();
    @Output() onGoToPageClicked = new EventEmitter<void>();
    @Input() isPreview = false;
    constructor(
        alarmMonitoringService: OpsAlarmMonitoringService,
        paginationStrategy: PaginationStrategy,
        responsive: ResponsiveService,
        cssVarService: CssVarService,
        private navigationService: NavigationService,
    ) {
        super(alarmMonitoringService, paginationStrategy, cssVarService, responsive);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngAfterViewInit(): void {}

    handleGoToPageClicked() {
        if (this.isPreview) {
            this.onGoToPageClicked.emit();
        } else {
            this.navigationService.toAlarms();
        }
    }

    handleDeleteClicked() {
        this.emitDeleteClicked();
    }

    emitDeleteClicked() {
        this.onDeleteClicked.emit();
    }

    onSetPage(page: number) {
        this.setPage(page);
    }

    public get pageStart() {
        return this.paginationStrategy.getPageStart(this._currentPage);
    }
}
